import Box, { BoxProps } from '@mui/material/Box';
import { styled } from '@mui/material/styles';
import { PropsWithChildren } from 'react';

type IDrawerActions = Pick<BoxProps, 'sx'>;

const StyledActions = styled(Box)(
    ({ theme }) => `
        padding-block: ${theme.spacing(2)};
        display: flex;
        justify-content: flex-end;
        align-items: center;
        gap: ${theme.spacing(1)};
    `
);

export const DrawerActions = ({ sx, children }: PropsWithChildren<IDrawerActions>) =>
    children ? <StyledActions sx={sx}>{children}</StyledActions> : null;
